import {svgIconWrapper} from '../svg-icon-wrapper';

import DiagramRegular from './diagram-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <DiagramRegular {...props} />;
}

SvgComponent.iconName = 'diagramRegular';

export const DiagramRegularIcon = svgIconWrapper(SvgComponent);
